export default __webpack_public_path__ + "static/media/2.bf2614f0.png";